import { Path } from '@/main/router/routerPath';

import { CRUMB_LABEL_KEY, NAME } from './constants';
import Edit from './Edit.vue';
import List from './List.vue';
import { ModelovyKlicTrida } from './modelovyKlicTrida';
import { ModelovyKlicSkupina } from './modelovyKlicSkupina';

export const router = new Path().addChildren([
	new Path(NAME, { List, Edit, SelectList: List }, CRUMB_LABEL_KEY),

	ModelovyKlicTrida.router,
	ModelovyKlicSkupina.router,
]);
